var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { LookupValueRequest } from "../../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
var LotteryInsurance = /** @class */ (function (_super) {
    __extends(LotteryInsurance, _super);
    function LotteryInsurance(notificationService, i18N, lookupService, signaler) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lookupService = lookupService;
        _this.signaler = signaler;
        _this.messageNotificationString = null;
        _this.isDataLoading = true;
        return _this;
    }
    Object.defineProperty(LotteryInsurance.prototype, "isReadonly", {
        get: function () {
            return !this.isEditable;
        },
        enumerable: false,
        configurable: true
    });
    LotteryInsurance.prototype.onActivated = function (item) {
        var _this = this;
        this.isDataLoading = true;
        if ('brandId' in item && item.brandId == 0) {
            this.messageNotificationString = "This is a new brand, currenctly doesn't have any lottery insurance info.";
        }
        else if ('operatorId' in item && item.operatorId == 0) {
            this.messageNotificationString = "This is a new operator, currenctly doesn't have any lottery insurance info.";
        }
        else {
            this.insuranceDataHandler.loadInsuranceData(this.item).then(function (x) {
                var request = new LookupValueRequest();
                request.lookupValueQuery = "insurers";
                _this.lookupService.getLookup(request).then(function (x) {
                    _this.insurers = x.values;
                    _this.onActivatedCompleted();
                });
                _this.isDataLoading = false;
            });
        }
    };
    LotteryInsurance.prototype.onActivatedCompleted = function () {
        var _this = this;
        setInterval(function () {
            _this.signaler.signal("updateInsurance");
        }, 2000);
    };
    LotteryInsurance.prototype.sortTiers = function (lottery) {
        return Enumerable.from(lottery.lotteryPriceTiers).orderBy(function (x) { return x.sequenceNumber; }).toArray();
    };
    LotteryInsurance.prototype.getTotalInsuranceCostForLotteryUI = function (lottery, range) {
        var total = this.getTotalInsuranceCostForLottery(lottery, range);
        return "€ " + total.toFixed(2);
    };
    LotteryInsurance.prototype.getTotalInsuranceCostForLottery = function (lottery, range) {
        var e_1, _a;
        var total = 0;
        var jackPotTier = null;
        try {
            //calculate all tiers except jackpot 
            for (var _b = __values(lottery.lotteryPriceTiers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tier = _c.value;
                if (tier.isJackpot) {
                    jackPotTier = tier;
                }
                else {
                    total += this.getInsuranceCost(tier, null);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // now get the cost for the range passed as paramater and add it
        total += this.getInsuranceCost(jackPotTier, range);
        return total < 0.01 ? 0.01 : total;
        //return total;
    };
    LotteryInsurance.prototype.getJackpotTierRanges = function (lottery) {
        var jackpot = Enumerable.from(lottery.lotteryPriceTiers).firstOrDefault(function (x) { return x.isJackpot; });
        if (jackpot) {
            return jackpot.lotteryJackpotRanges;
        }
        return null;
    };
    LotteryInsurance.prototype.getInsuranceCost = function (tier, range) {
        if (!tier)
            return 0;
        var policy = this.getInsurancePolicy(tier);
        if (!policy) {
            console.log("No policy found for tier " + tier.name);
            return 0;
        }
        var operatorPolicy = this.getOperatorInsurancePolicy(tier);
        if (operatorPolicy && !operatorPolicy.isActive) // operator polisy is no good to us if it is not active 
         {
            operatorPolicy = null;
        }
        //if the brand policy is not active and the operator policy is then fallback to that 
        if (!policy.isActive && operatorPolicy) {
            policy = operatorPolicy;
        }
        if (!policy.shouldInsure) {
            return 0;
        }
        var insurer = Enumerable.from(this.insurers).firstOrDefault(function (x) { return x.id == policy.insurerId; });
        if (!insurer) {
            return 0;
        }
        var winningAmount = tier.winningAmount; //policy.winningAmount ? policy.winningAmount :
        //(operatorPolicy && operatorPolicy.winningAmount ? operatorPolicy.winningAmount : tier.winningAmount);
        var minWinners = tier.minimumWinners; // policy.minimumWinners ? policy.minimumWinners :
        //(operatorPolicy && operatorPolicy.minimumWinners ? operatorPolicy.minimumWinners : tier.minimumWinners);
        minWinners = Math.max(1, minWinners);
        var amount = range ? range.rangeTo : winningAmount;
        //if fixed amount then we do not need to divide the value 
        // 05-12-2019 +1 for the fixed was added because emirates contracts are not yet updated
        var amountToInsure = policy.isFixedAmount ? (amount / (minWinners + 1)) : amount / (minWinners + 1);
        var insuranceFactor = insurer.additionalData["insuranceFactor"];
        var insuranceCost = amountToInsure / tier.odds * 1 * Number(insuranceFactor);
        return insuranceCost;
    };
    LotteryInsurance.prototype.getInsuranceCostUI = function (tier, range) {
        var insuranceCost = this.getInsuranceCost(tier, range);
        return insuranceCost == 0 ? "N/A" : "€ " + insuranceCost.toFixed(5);
    };
    LotteryInsurance.prototype.getOperatorInsuranceCostUI = function (tier, range) {
        var insuranceCost = this.getInsuranceCost(tier, range);
        return insuranceCost == 0 ? "N/A" : "€ " + insuranceCost.toFixed(5);
    };
    LotteryInsurance.prototype.getInsurancePolicy = function (tier) {
        var policy = Enumerable.from(this.item.lotteryPriceTierInsurancePolicies).firstOrDefault(function (x) { return x.lotteryPriceTierId == tier.lotteryPriceTierId; });
        if (!policy) {
            policy = {
                lotteryPriceTierId: tier.lotteryPriceTierId,
                shouldInsure: false,
                insurerId: null,
                isActive: false,
                lotteryPriceTierInsurancePolicyId: 0,
                minimumWinners: null,
                winningAmount: null,
                isFixedAmount: false
            };
            if ('brandId' in this.item) {
                policy["brandId"] = this.item.brandId;
            }
            else if ('operatorId' in this.item) {
                policy["operatorId"] = this.item.operatorId;
            }
            this.item.lotteryPriceTierInsurancePolicies.push(policy);
        }
        return policy;
    };
    LotteryInsurance.prototype.getOperatorInsurancePolicy = function (tier) {
        if (this.insuranceDataHandler.operatorPoliciesApplied && tier) {
            return Enumerable.from(this.insuranceDataHandler.operatorPoliciesApplied).firstOrDefault(function (x) { return x.lotteryPriceTierId == tier.lotteryPriceTierId && x.isActive; });
        }
        return null;
    };
    LotteryInsurance.prototype.onEnter = function (event) {
        if (event.detail && event.detail.keyCode == 13) {
            this.signaler.signal('updateLotteryInsurance');
        }
        else if (event.detail && event.detail.keyCode == 8 && !this.searchQuery) {
            this.signaler.signal('updateLotteryInsurance');
        }
    };
    LotteryInsurance.prototype.showPriceTier = function (lottery) {
        if (this.searchQuery) {
            var searchResultNum = lottery.name.toLowerCase().includes(this.searchQuery.toLowerCase());
            if (searchResultNum)
                return true;
            return false;
        }
        else
            return true;
    };
    LotteryInsurance = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            LookupClientService, BindingSignaler])
    ], LotteryInsurance);
    return LotteryInsurance;
}(ChildComponent));
export { LotteryInsurance };
